import lodash from 'lodash';

const getHeaderFromParams = (params) => {
  const reqData = {
    'token': lodash.get(params, 'auth_token'),
    'source_id': lodash.get(params, 'source_id'),
    'partner_id': 'ril',
    'partner_user_info': {
      'id': lodash.get(params, 'source_user_id'),
      'relation': lodash.get(params, 'source_relation'),
      'relation_id': lodash.get(params, 'source_user_relation_id')
    }
  }
  return reqData;
}

export default getHeaderFromParams;